import React, { useState } from 'react';
import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import CommonEmployerChooseInput from '@/src/components/inputs/CommonEmployerChooseInput';
import { LLButton, LLLink } from '@/components-library';
import { Resources } from '@/src/shared/constants/resources';

export default function AdminSwitchModal() {
  return (
    <Box>
      <DialogTitle id="admin-switch-title">Switch to Admin View</DialogTitle>
      <DialogContent>
        <DialogContentText id="admin-switch-description">
          To access features of this app you need a Club administrative access. If someone
          added you to their team, you can choose a Club Owner to switch to.
        </DialogContentText>
        <CommonEmployerChooseInput
          variant="outlined"
          size="small"
          fullWidth
          sx={{ mt: 2 }}
        />
      </DialogContent>
      <DialogActions>
        <LLLink to={`/${Resources.ClubProfile}/create`}>
          <LLButton
            color="secondary"
            variant="contained"
            sx={{ m: 2, mr: 0, mt: 0, color: 'common.white' }}
          >
            Create a Club
          </LLButton>
        </LLLink>
        <LLLink to={`/logout`}>
          <LLButton variant="contained" sx={{ m: 2, mt: 0 }}>
            Sign out
          </LLButton>
        </LLLink>
      </DialogActions>
    </Box>
  );
}
